<template>
    <div class="container">
        <Header></Header>
        <div>
            <!--v-if="windowWidth>maxMobilSize"-->
            <grid @editProcess="getProcessId($event)" @deleteProcess="deleteProcess($event)" :columns="gridColumns" :tableConfigVisible="tableConfigVisible" :user="user" :users="users" :page="pageIs" :data="gridData"></grid>
        </div>

        <!-- Add Process Modal -->
        <div class="modal fade" id="addProcessModal" tabindex="-1" aria-labelledby="addProcessModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title createProcessModalHeader" id="addProcessModalLabel">{{$ml.get('CREATE_PROCESS')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="clearModal()">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pt-3 pb-5">
                    <div class="row">
                            <div class="col-12">
                                <label class="new-label">{{$ml.get('PROCESS_NAME')}}</label>
                                <input type="text" v-model="processName" class="new-input">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <label class="new-label">{{$ml.get('FORMS')}}</label>
                                <select class="new-select bg-white" v-if="isEditMode == false" @change="changeForm($event)">
                                    <option disabled selected>{{$ml.get('SELECT')}}</option>
                                    <option  v-for="(form,index) in listForms" :key="index" :value="form._id.$oid" :selected="selectedFormId === form._id.$oid">{{form.name}}</option>
                                </select>
                                <select disabled class="new-select bg-white" v-else  @change="changeForm($event)">
                                    <option v-for="(form,index) in listForms" :key="index" :value="form._id.$oid" :selected="selectedFormId === form._id.$oid">{{form.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer noteBtnStyle">
                        <button type="button" class="btn-new" data-dismiss="modal" @click="clearModal()">{{$ml.get('CANCEL')}}</button>
                        <button v-if="isEditMode == false" @click="addProcessF()"  type="button" class="btn-new save ml-1">{{$ml.get('SAVE')}}</button>
                        <button v-else @click="updateProcessF('edit')" type="button" class="btn-new save ml-1">{{$ml.get('UPDATE')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <notifications group="foo" style="margin-right:5%;margin-top:2%" position="top right" />
    </div>
    
</template>

<script>
    import axios from 'axios'
    import { mapState } from 'vuex'
    import Grid from './Grid'
    import GridMobil from "./gridMobil"
    
    export default {
        name: "adminProcess",
        components: {
            "grid":Grid,
            "gridMobil":GridMobil,
        },
        props: ['user', 'users'],
        data () {
            return {
                firstLoad:true,
                gridColumns:[
                    {prop:'_id',name:"Id",default:true},
                    {prop:'name',name:this.$ml.get('PROCESS_NAME'),default:true,type:"name",valid:true},
                    {prop:'form',name:this.$ml.get('FORM_NAME'),default:true,type:"formObj",valid:true},
                    {prop:'add_date',name:this.$ml.get('CREATION_DATE'), type:"dateObj", default:true, valid:true},
                    {prop:'cuid', name: this.$ml.get('CREATED_BY'), type:"user", default:true},
                ],
                tableConfigVisible:[],
                gridData:[],
                processList: [],
                pageIs:'adminProcess',
                processName: "",
                listForms: [],
                selectedFormId: "",
                updateProcessData: {},
                isEditMode: false
            }
        },
        computed:{
            ...mapState([
                'baseUrl',
                'windowWidth',
                'maxMobilSize',
                'maxTabletSize',
            ]),
        },
        created() {
            this.$root.$refs.adminProcess = this
        },
        methods: {
            addProcessModal() {
                $('#addProcessModal').modal('show')
            },
            addProcessF() {
                if(this.processName !== "" && this.selectedFormId !== ""){
                    let form = {}

                    form.form_id = this.selectedFormId
                    form.data = {}
                    form.current_step = "start"
                    form.name = this.processName
                    form.customerFileIds = []

                    axios({
                        method:'POST',
                        url:'/addProcess',
                        baseURL: this.baseUrl,
                        data: form,
                        withCredentials:true
                        }).then((res)=>{
                            return res
                        }).then((res)=>{
                        if(res.data.status){
                            if(res.data.status.code==0){
                                $('#addProcessModal').modal('hide')
                                this.getAllProcessesF()
                            }
                        }else{
                    
                        }
                    })
                }
                else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('WARNING'),
                        text: "Process name ve forms alanı boş geçilemez."
                    })
                }
            },
            updateProcessF(type, obj){
                let form = {}
                if(type=="delete"){
                    form = obj
                }
                else{
                    if(this.processName !== "" && this.selectedFormId !== "") {
                        
                        form.current_step = this.updateProcessData.current_step
                        form.data = this.updateProcessData.data
                        form.form_id = this.updateProcessData.form_id
                        form.name = this.processName
                        form.customerFileIds = this.updateProcessData.customerFileIds
                        form.process_id = this.updateProcessData._id.$oid
                        
                    }
                    else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'warning', 
                            title: this.$ml.get('WARNING'),
                            text: "Process name ve forms alanı boş geçilemez."
                        })
                        return false
                    }
                }
                axios({
                    method:'POST',
                    url:'/updateProcess',
                    baseURL: this.baseUrl,
                    data: form,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            $('#addProcessModal').modal('hide')
                            this.getAllProcessesF()
                        }
                    }else{
                    
                    }
                })
            },
            deleteProcess(event) {
                for(let item of this.processList){
                    if(event === item._id.$oid){
                        let form = {}

                        form.current_step = item.current_step
                        form.data = item.data
                        form.form_id = item.form_id
                        form.name = item.name
                        form.process_id = item._id.$oid
                        form.customerFileIds = item.customerFileIds
                        form.isActive = false

                        this.updateProcessF("delete", form)
                    }
                }
                
            },
            getProcessId(event) {
                this.isEditMode = true
                this.getProcessF(event)

            },
            changeForm(event) {
                this.selectedFormId = event.target.value
            },
            getAllProcessesF() {
                axios({
                    method:'POST',
                    url:'/getAllProcesses',
                    baseURL: this.baseUrl,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.processList = res.data.content.processes[0]
                            if(this.firstLoad){
                                for(var col in this.gridColumns){
                                    if(this.gridColumns[col]['default']){
                                        this.tableConfigVisible.push(this.gridColumns[col]['prop'])
                                    }
                                }
                            }

                            this.firstLoad=false
                            if(res.data.content.processes){
                                var processList = []
                                let columns = this.gridColumns
                                for (var formObjIter in res.data.content.processes[0]){
                                    let obj={}
                                    let formObj =res.data.content.processes[0][formObjIter]
        
                                    for(var column in columns){
                                        var colInActivity = formObj.hasOwnProperty(columns[column]['prop'])
                                        if(colInActivity){
                                            
                                            let edObj={}
                                             
                                            edObj['val']=formObj[columns[column]['prop']]
                                            
                                            edObj['isEditMode']=false
                                            edObj['type']=columns[column]['type']
                                            obj[columns[column]['prop']]=edObj
                                        }else{
                                            let edObj={}
                                            edObj['val']=null
                                            edObj['isEditMode']=false
                                            edObj['type']=columns[column]['type']
                                            
                                            if(columns[column]['type']=='dateObj'){
                                                let date = {}
                                                date['$date']=''
                                                edObj['val']=date
                                            }
                                            obj[columns[column]['prop']]=edObj
                                        }
                                    }
                                    processList.push(obj)
                                    
                                }
                                this.gridData = processList
                                processList.reverse()
                            }
                        }
                    }
                })
            },
            getAllFormsF(){
                axios({
                    method:'POST',
                    url:'/getAllForms',
                    baseURL: this.baseUrl,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.listForms = res.data.content.forms[0]
                        }
                    }else{

                    }
                })
            },
            getProcessF(id){
                axios({
                    method:'POST',
                    url:'/getProcess',
                    baseURL: this.baseUrl,
                    data: {
                        processId: id,
                    },
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.selectedFormId = res.data.content.process.form_id
                            this.processName = res.data.content.process.name
                            this.updateProcessData = res.data.content.process
                            this.addProcessModal()
                        }else{
                            
                        }
                    }else{
                        
                    }
                })
            },
            clearModal() {
                this.processName = ""
                this.selectedFormId = ""
                this.isEditMode = false
            }
        },
        mounted() {
            this.getAllProcessesF()
            this.getAllFormsF(  )
        },
    }
</script>

<style scoped>

</style>